angular.module('westBerkshireEvents.blConfirmation').directive('blConfirmation', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: true,
        controller: blConfirmation
    };
});

function blConfirmation($scope, $attrs, $rootScope, $log, $location, $http, AlertService) {

    // load the booking from the purchase long id
    const paymentRequest = {
        "child_company": $scope.bb.company_id,
        "host": $scope.bb.api_url
    }

    if ($location.search().purchase_id) {
        $http({
            method: 'POST',
            url:  `https://api.bookinglab.co.uk/payment/hey-centric/find/${$location.search().purchase_id}`,
            data: JSON.stringify(paymentRequest),
            headers: { 'Content-Type': 'application/json' }
        }).then(response => {
            console.log(response);
            $scope.bb.total = response.data;
            $scope.bb.total.client = response.data['_embedded'].client;
            $scope.bb.total.bookings = response.data['_embedded'].bookings;

            //  now confirm the booking!
            const payRequest = {
                "child_company": $scope.bb.company_id,
                "host": $scope.bb.api_url,
                "purchase_id": $location.search().purchase_id
            };

            if ($scope.bb.extra_setup.rc && $scope.bb.extra_setup.rc === 'A') {
                $http({
                    method: 'POST',
                    url: `https://api.bookinglab.co.uk/payment/hey-centric/pay`,
                    data: JSON.stringify(payRequest),
                    headers: { 'Content-Type': 'application/json' }
                }).then(response => {
                }, err => {
                    AlertService.danger({ msg: "Unable to confirm booking" });
                    console.log(err);
                });
            }
            else {
                $http({
                    method: 'POST',
                    url: `https://api.bookinglab.co.uk/payment/hey-centric/cancel`,
                    data: JSON.stringify(payRequest),
                    headers: { 'Content-Type': 'application/json' }
                }).then(response => {
                }, err => {
                    AlertService.danger({ msg: "Unable to cancel booking" });
                    console.log(err);
                });
            }
        }, err => {
            AlertService.danger({ msg: "Payment request failed" });
            console.log(err);
        });
    }
}


// WEBPACK FOOTER //
// ../src/public/javascripts/bl-confirmation/bl-confirmation.directive.js